<script setup>
/**
 * Label op een categoriekaart (NIEUW, Veel gekozen, …).
 * variant: 'new' | 'popular' | 'custom'
 */
defineProps({
  text: { type: String, required: true },
  variant: { type: String, default: 'custom' }
});
</script>

<template>
  <span class="vsb-item-badge" :class="'vsb-item-badge--' + variant">
    <svg
      v-if="variant === 'popular'"
      class="vsb-item-badge__icon"
      width="14"
      height="14"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M9 12l2 2 4-4m5-2a9 9 0 11-18 0 9 9 0 0118 0z"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
    {{ text }}
  </span>
</template>

<style scoped>
.vsb-item-badge {
  position: absolute;
  top: 12px;
  left: 12px;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.35rem 0.65rem;
  background: var(--vsb-cart-badge-bg, #22c55e);
  color: var(--vsb-cart-badge-color, #fff);
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
}

.vsb-item-badge--new {
  background: var(--vsb-cart-badge-new-bg, #0b3d91);
  color: var(--vsb-cart-badge-new-color, #fff);
}

.vsb-item-badge__icon {
  flex-shrink: 0;
}
</style>
